import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from '../../locales/es.json';
import en from '../../locales/en.json';
import { clienteOverrides } from './clienteOverrides';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
    },
    lng: localStorage.getItem('lang') || 'es',
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false, // React already escapes
    },
  });

// Aplicar el vocabulario de la organización activa (condominio vs cliente) al
// cargar la app, según lo guardado en localStorage durante el login.
if ((localStorage.getItem("condominio_tipo") || "condominio") === "cliente") {
  ["es", "en"].forEach((lng) => {
    i18n.addResourceBundle(lng, "translation", clienteOverrides[lng], true, true);
  });
}

export default i18n;
